/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import {
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Loading from "../components/Loading";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import qs from "qs";
import SearchIcon from "@mui/icons-material/Search";

import {
  Alert,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Link,
  Paper as MuiPaper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { Add as AddIcon, Download, PersonRemove } from "@mui/icons-material";
import { spacing } from "@mui/system";
import { makeStyles, withStyles } from "@mui/styles";
import axios from "../../CustomAxios";
import { connect } from "react-redux";
import CustomerUserFilter from "./CustomerUserFilter";
import { CSVLink } from "react-csv";
import moment from "moment";

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const useStyles = makeStyles({
  tableCell: {
    padding: "0px 12px 0px 0px",
    width: "1000px",
  },
});

const StyledTableContainer = withStyles((theme) => ({
  root: {
    // width: "max-content",
  },
}))(TableContainer);

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function createData(
  name,
  email,
  mobile,
  address_line_one,
  address_line_two,
  pincode,
  state,
  city,
  company,
  role,
  id,
  address,
  is_deleted
) {
  return {
    name,
    email,
    mobile,
    address_line_one,
    address_line_two,
    pincode,
    state,
    city,
    company,
    role,
    id,
    address,
    is_deleted,
  };
}

const headCells = [
  { key: "name", alignment: "left", label: "Name" },
  { key: "email", alignment: "left", label: "Email" },
  { key: "mobile", alignment: "left", label: "Phone Number" },
  { key: "address", alignment: "left", label: "Address" },
  { key: "company", alignment: "left", label: "Company Name" },
  { key: "role", alignment: "left", label: "Role Name" },
];

const getUsers = async (
  authData,
  setLoader,
  setRows,
  customerCompany,
  sortingField,
  sortingOrder,
  search,
  page,
  limit,
  setTotal,
  deleted
) => {
  try {
    setLoader(true);
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    let url = "";
    if (authData?.type === "customer_user") {
      url = `/api/v1/customer_user/ops?sorting_field=${sortingField}&sorting_order=${sortingOrder}&search_keyword=${search}&company_id=${customerCompany}&page=${
        page + 1
      }&limit=${limit}&include_deleted=${deleted}`;
    } else {
      url = `/api/v1/${
        authData?.type
      }/customer_company_user?sorting_field=${sortingField}&sorting_order=${sortingOrder}&search_keyword=${search}&company_id=${customerCompany}&page=${
        page + 1
      }&limit=${limit}&include_deleted=${deleted}`;
    }
    const { data } = await axios.get(url, config);

    if (data.success) {
      const users = data.data.data;
      setTotal(data.data.metadata.total_results);

      let rows = [];
      users.map((user) => {
        rows.push(
          createData(
            user.name,
            user.email_address,
            user.phone_number,
            user.address_line_one,
            user.address_line_two,
            user.pincode,
            user.state,
            user.city,
            user.company_details[0].name,
            user.role_details[0].role_name,
            user._id,
            user.address_line_one +
              ", " +
              user.address_line_two +
              ", " +
              user.city +
              "," +
              user.state +
              ", " +
              user.pincode +
              ", " +
              "India",
            user?.is_deleted
          )
        );
      });
      setRows(rows);
      setLoader(false);
    }
  } catch (error) {
    console.log(error);
    setLoader(false);
  }
};

const EnhancedTableHead = (props) => {
  const { viewPermission, editPermission } = props;
  const authData = JSON.parse(localStorage.getItem("AuthData"));

  const [head, setHeads] = useState(headCells);
  useEffect(() => {
    if (viewPermission) {
      setHeads((prev) => [
        ...prev,
        { id: "view", alignment: "center", label: "View" },
      ]);
    }
    if (editPermission) {
      setHeads((prev) => [
        ...prev,
        { id: "edit", alignment: "center", label: "Edit" },
      ]);
    }
    if (authData.type === "super_admin") {
      setHeads((prev) => [
        ...prev,
        { id: "delete", alignment: "center", label: "Delete" },
      ]);
    }
  }, [viewPermission, editPermission]);

  return (
    <TableHead>
      <TableRow>
        {head.map((headCell) => (
          <TableCell
            // style={{ width: 100 }}
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "normal"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  // Here was 'let'
  const {
    setFilter,
    sortingField,
    sortingOrder,
    setSortingField,
    setSortingOrder,
    search,
    setSearch,
    customerCompany,
    setCustomerCompany,
    companies,
    rows,
    setOnSearch,
    isDeleted,
    setIsDeleted,
    csvPermission,
  } = props;
  const navigate = useNavigate();

  let timestamp = moment().format("DD-MM-YY HH:mm");

  const csvReport = {
    filename: `Customer_Users_${timestamp}.csv`,
    headers: headCells,
    data: rows,
  };
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        setOnSearch(true);
      }}
    >
      <Toolbar>
        <ToolbarTitle>
          <Typography variant="h6" id="tableTitle">
            Users
          </Typography>
        </ToolbarTitle>
        <Spacer />
        {csvPermission && (
          <CSVLink
            style={{ color: "green", textDecoration: "none" }}
            {...csvReport}
          >
            <Button
              variant="outlined"
              sx={{ ml: 2, mr: 2 }}
              endIcon={<Download />}
            >
              CSV
            </Button>
          </CSVLink>
        )}
        <TextField
          value={search}
          size="small"
          style={{ width: "100%", marginRight: 10 }}
          label="Search"
          placeholder="Name/ Email/ Phone Number"
          onChange={(e) => setSearch(e.target.value)}
        />

        <Button
          endIcon={<SearchIcon />}
          style={{ width: "20%" }}
          variant="contained"
          type="submit"
        >
          Search
        </Button>

        <CustomerUserFilter
          setFilter={setFilter}
          sortingField={sortingField}
          sortingOrder={sortingOrder}
          setSortingField={setSortingField}
          setSortingOrder={setSortingOrder}
          customerCompany={customerCompany}
          setCustomerCompany={setCustomerCompany}
          companies={companies}
          isDeleted={isDeleted}
          setIsDeleted={setIsDeleted}
        />
        <Tooltip title="Register User">
          <IconButton>
            <AddIcon
              onClick={() => navigate("/dashboard/users/customer-users/add/")}
            />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </form>
  );
};

function EnhancedTable({
  rows,
  viewPermission,
  editPermission,
  sortingField,
  setFilter,
  sortingOrder,
  setSortingField,
  setSortingOrder,
  search,
  setSearch,
  customerCompany,
  setCustomerCompany,
  companies,
  setOnSearch,

  page,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  total_results,
  isDeleted,
  setIsDeleted,
  csvPermission,
}) {
  const navigate = useNavigate();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("customer");
  const [selected, setSelected] = React.useState([]);

  const location = useLocation();
  const [message, setMessage] = useState(location?.state?.message);
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const [loader, setLoader] = useState(false);
  const [err, setErr] = useState("");
  const authData = JSON.parse(localStorage.getItem("AuthData"));

  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const deleteUser = async (id) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };

      const { data } = await axios.delete(
        `/api/v1/${authData.type}/customer_company_user/${id}`,
        config
      );

      if (data.success) {
        setMessage("User Deleted Successfully");
        setFilter(true);
      }
    } catch (e) {
      setLoader(false);
      console.log(e);
      setErr(e.response.data.error);
      snackRef.current.click();
    }
  };

  useEffect(() => {
    if (location?.state?.success) {
      snackRef.current.click();
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <div>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        {err ? (
          <Alert mt={2} mb={4} severity="error">
            {err}
          </Alert>
        ) : (
          <Alert mt={2} mb={4} severity="success">
            {message}
          </Alert>
        )}
      </Snackbar>
      <Paper>
        <EnhancedTableToolbar
          setOnSearch={setOnSearch}
          setFilter={setFilter}
          sortingField={sortingField}
          sortingOrder={sortingOrder}
          setSortingField={setSortingField}
          setSortingOrder={setSortingOrder}
          search={search}
          customerCompany={customerCompany}
          setCustomerCompany={setCustomerCompany}
          setSearch={setSearch}
          companies={companies}
          numSelected={selected.length}
          rows={rows}
          isDeleted={isDeleted}
          setIsDeleted={setIsDeleted}
          csvPermission={csvPermission}
        />
        <StyledTableContainer>
          <Table size={"small"}>
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              viewPermission={viewPermission}
              editPermission={editPermission}
            />
            <TableBody>
              {rows.map((row, index) => {
                return (
                  <TableRow
                    role="checkbox"
                    tabIndex={-1}
                    key={`${row.id}-${index}`}
                    style={{
                      backgroundColor: row?.is_deleted ? "#eeaa9c" : "#fff",
                   }}
                  >
                    <TableCell align="left">{row.name}</TableCell>
                    <TableCell align="left">{row.email}</TableCell>
                    <TableCell align="left">{row.mobile}</TableCell>
                    <TableCell align="left">
                      {row.address_line_one}, {row.address_line_two}, {row.city}
                      , {row.state}, {row.pincode}, India
                    </TableCell>
                    <TableCell align="left">{row.company}</TableCell>
                    <TableCell align="left">{row.role}</TableCell>
                    {viewPermission ? (
                      <TableCell align="center">
                        <VisibilityIcon
                          style={{ cursor: "pointer", color: "green" }}
                          onClick={() =>
                            navigate(
                              `/dashboard/users/customer-users/${row.id}`,
                              {
                                state: {
                                  id: row.id,
                                },
                              }
                            )
                          }
                        />
                      </TableCell>
                    ) : null}
                    {editPermission ? (
                      <TableCell align="center">
                        <EditIcon
                          style={{ cursor: "pointer", color: "skyBlue" }}
                          onClick={() =>
                            navigate(
                              `/dashboard/users/customer-users/update-customer-user/${row.id}`,
                              {
                                state: { id: row.id },
                              }
                            )
                          }
                        />
                      </TableCell>
                    ) : null}
                    {authData.type === "super_admin" && (
                      <TableCell align="center">
                        {!row.is_deleted ? (
                          <PersonRemove
                            sx={{ color: "red", cursor: "pointer" }}
                            onClick={() => deleteUser(row.id)}
                          />
                        ) : (
                          <PersonRemove
                            sx={{ color: "grey", cursor: "pointer" }}
                            // onClick={() => deleteUser(row.id)}
                          />
                        )}
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </StyledTableContainer>
        <TablePagination
          rowsPerPageOptions={[50, 100, 250]}
          component="div"
          count={total_results}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}

const getCompanies = async (setCompanies) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    const companydata = await axios.get(
      `/api/v1/${userData.type}/customer_company?limit=500`,
      config
    );
    if (companydata.data.success) {
      setCompanies(companydata.data.data.data);
    }
  } catch (e) {
    console.log(e);
  }
};

function CustomerUsers({ auths }) {
  const token = JSON.parse(localStorage.getItem("AuthData"));
  const [loader, setLoader] = useState(true);
  const [rows, setRows] = useState([]);
  const [viewPermission, setViewPermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  const [csvPermission, setCsvPermission] = useState(false);

  const [sortingField, setSortingField] = useState("updated_at");
  const [sortingOrder, setSortingOrder] = useState("desc");
  const [companies, setCompanies] = useState([]);

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const [search, setSearch] = useState(
    searchParams.get("search_keyword") || ""
  );
  const [customerCompany, setCustomerCompany] = useState(
    searchParams.get("customer_company_id") || ""
  );

  const [page, setPage] = React.useState(
    searchParams.get("page") ? Number(searchParams.get("page")) : 0
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(
    searchParams.get("limit") ? Number(searchParams.get("limit")) : 50
  );
  const [isDeleted, setIsDeleted] = React.useState(
    searchParams.get("include_deleted") || false
  );

  const [total, setTotal] = useState(0);
  const [onSearch, setOnSearch] = useState(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [filter, setFilter] = useState(true);
  useEffect(async () => {
    let sk = search || "";
    let sorting_field = sortingField || "";
    let sorting_order = sortingOrder || "";
    let customer_company = customerCompany || "";
    let deleted = isDeleted;

    if (filter || onSearch) {
      navigate(
        `/dashboard/users/customer-users?sorting_field=${sortingField}&sorting_order=${sortingOrder}&search_keyword=${sk}&customer_company_id=${customerCompany}&include_deleted=${deleted}`,
        { replace: true }
      );
      getUsers(
        token,
        setLoader,
        setRows,
        customerCompany,
        sortingField,
        sortingOrder,
        sk,
        page,
        rowsPerPage,
        setTotal,
        deleted
      );

      setFilter(false);
      setOnSearch(false);
    } else {
      navigate(
        `/dashboard/users/customer-users?sorting_field=${sortingField}&sorting_order=${sortingOrder}&search_keyword=${search}&customer_company_id=${customerCompany}&include_deleted=${deleted}`,
        { replace: true }
      );
      getUsers(
        token,
        setLoader,
        setRows,
        customerCompany,
        sortingField,
        sortingOrder,
        search,
        page,
        rowsPerPage,
        setTotal,
        deleted
      );
      setFilter(false);
      setOnSearch(false);
    }
  }, [
    onSearch,
    filter,
    page,
    rowsPerPage,
    // , customerCompany, sortingOrder, sortingField
  ]);

  useEffect(() => {
    if (
      auths?.user?.role?.permissions.includes(
        "view_customer_company_user_profile"
      ) ||
      token?.type === "super_admin"
    ) {
      setViewPermission(true);
    }
    if (
      [
        "view_customer_company_list",
        "view_customer_company_user_profile",
        "view_role",
        "update_customer_company_user",
      ].every((k) => auths?.user?.role?.permissions.includes(k)) ||
      token?.type === "super_admin"
    ) {
      setEditPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes("download_csv") ||
      token?.type === "super_admin"
    ) {
      setCsvPermission(true);
    }
    getCompanies(setCompanies);
  }, [auths.user]);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              CUSTOMER USERS
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Typography>Customer Users</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <EnhancedTable
              setOnSearch={setOnSearch}
              setFilter={setFilter}
              viewPermission={viewPermission}
              editPermission={editPermission}
              rows={rows}
              sortingField={sortingField}
              sortingOrder={sortingOrder}
              setSortingField={setSortingField}
              setSortingOrder={setSortingOrder}
              search={search}
              setSearch={setSearch}
              customerCompany={customerCompany}
              setCustomerCompany={setCustomerCompany}
              companies={companies}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              rowsPerPage={rowsPerPage}
              total_results={total}
              isDeleted={isDeleted}
              setIsDeleted={setIsDeleted}
              csvPermission={csvPermission}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(CustomerUsers);
